import { Config } from "../../../configurations/config";
export const CM_APIs = {
  EditTicketByCM_API: `${Config.server_url}${Config.api_prefix}/Ticket/EditTicketByCM`,
  CMTicketListing_API: `${Config.server_url}${Config.api_prefix}/Ticket/GetAllTickets`,
  CMAssignedTickets_API: `${Config.server_url}${Config.api_prefix}/Ticket/GetAssignedTickets`,
  CMTicketDetails_API: `${Config.server_url}${Config.api_prefix}/Ticket/GetTicketDetails?ticketId=`,
};
